export enum ViewControlsEnum {
  List = 'list',
  Grid = 'grid',
  Delete = 'delete',
  ImportPlaylist = 'importPlaylist',
  SelectAll = 'selectAll',
  Search = 'search',
  Language = 'language',
  View = 'view',
  Reload = 'reload',
  AttachNewRelease = 'attachNewRelease',
  DisableAll = 'disableAll',
  EnableAll = 'enableAll',
  Disable = 'disable',
  Enable = 'enable'
}

export interface ViewControlsProps {
  selectedRows?: string[] | undefined;
  onAction: (action: { type: string; value?: any }) => void;
  showImport?: boolean;
  showDelete?: boolean;
  showRelease?: boolean;
  showLanguageSelect?: boolean;
  showReload?: boolean;
  isReloading?: boolean;
  extraButtons?: React.ReactNode;
}
